import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './Landing';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import Terms from './Terms';
import Privacy from './Privacy';
import Home from './Home';
import withRoot from './modules/withRoot';

function App() {
  return (
    <Router>
      <React.Fragment>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/home" element={<Home />} />
        </Routes>
      </React.Fragment>
    </Router>
  );
}

export default withRoot(App);
